/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CompanyPageRequestDto } from '../models/company-page-request-dto';
import { CompanyPageResponseDto } from '../models/company-page-response-dto';

@Injectable({
  providedIn: 'root',
})
export class CompanyService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation findCompanies
   */
  static readonly FindCompaniesPath = '/companies';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findCompanies()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findCompanies$Response(params?: {
    body?: CompanyPageRequestDto
  }): Observable<StrictHttpResponse<CompanyPageResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.FindCompaniesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CompanyPageResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findCompanies$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findCompanies(params?: {
    body?: CompanyPageRequestDto
  }): Observable<CompanyPageResponseDto> {

    return this.findCompanies$Response(params).pipe(
      map((r: StrictHttpResponse<CompanyPageResponseDto>) => r.body as CompanyPageResponseDto)
    );
  }

}
